import { Component } from '@angular/core'
import { ThemeService } from 'app/shared/services/app-theme.service'
import { ContentLayoutComponent } from '../../content-layout.component'
import { DividerModule } from 'primeng/divider';
import { Button } from 'primeng/button';
import { NgFor, NgClass } from '@angular/common';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-side-bar-theme-config',
    templateUrl: './side-bar-theme-config.component.html',
    styleUrls: ['./side-bar-theme-config.component.scss'],
    standalone: true,
    imports: [
        DividerModule,
        Button,
        NgFor,
        NgClass,
        InputSwitchModule,
        FormsModule,
    ],
})
export class SidebarThemeConfigComponent {
  scales: any[] = [11, 12, 13, 14, 15, 17, 18]

  constructor(public themeService: ThemeService, public contentLayout: ContentLayoutComponent) {
    if (!this.themeService.config.fontSize) {
      this.themeService.config.fontSize = this.scales[Math.floor(this.scales.length / 2)]
    }
  }

  incrementScale() {
    this.themeService.setFontSize(this.scales[this.scales.indexOf(this.themeService.config.fontSize) + 1])
  }

  decrementScale() {
    this.themeService.setFontSize(this.scales[this.scales.indexOf(this.themeService.config.fontSize) - 1])
  }

  changeTheme(isDarkTheme: boolean) {
    this.themeService.setTheme(isDarkTheme ? 'bootstrap4-dark-blue' : 'bootstrap4-light-blue', isDarkTheme)
  }
}
